<template>
  <nuxt-link
    to="/sok"
    class="inline-flex h-12 items-center gap-2 rounded-full border border-purple-lighter bg-white px-4 text-slate-darker hover:border-purple-dark focus:outline-none focus:ring-2 focus:ring-purple-lighter"
  >
    <icon-search class="h-5 w-5 text-purple-dark"></icon-search>
    <span class="hidden sm:inline">Sök</span>
  </nuxt-link>
</template>

<script lang="ts" setup></script>
